// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import es6Promise from 'es6-promise';
import VueBar from 'vuebar';
import VueFilter from 'vue-filter';
import * as VueGoogleMaps from 'vue2-google-maps'

// Promise polyfill for IE11
es6Promise.polyfill();

Vue.config.productionTip = false;
Vue.use(VueBar);
Vue.use(VueFilter);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBYZaHIGxf8gHHBjycxCilYSi_OAffeaYY',
    //libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js